export default __webpack_public_path__ + "static/media/cate.3a35920c.jpeg";